import * as React from 'react'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'

export const isExternalLink = (url) => url && url.substring(0, 1) !== '/'

// Generate ARIA label for link
// Only return a string value - never a React node
const generateAriaLabel = (ariaLabel, icon, children) => {
  if (ariaLabel) return ariaLabel
  if (icon && !children) return `${icon} link`
  // Only use children as aria-label if it's a string
  // React nodes would render as [object Object]
  if (typeof children === 'string') return children
  return undefined
}

export const extraAttributes = (url) => {
  const extra = {}
  // to external links, add target and rel for security / UX
  if (isExternalLink(url)) {
    extra.target = '_blank'
    extra.rel = 'noopener noreferrer'
  }

  return extra
}

const Link = ({ href, children, ariaLabel, icon, ...rest }) => {
  const extra = extraAttributes(href)
  const ariaLabelValue = generateAriaLabel(ariaLabel, icon, children)

  if (isExternalLink(href)) {
    return (
      <a href={href} {...extra} {...rest} aria-label={ariaLabelValue}>
        {children}
      </a>
    )
  }

  return (
    <GatsbyLink to={href} {...rest} aria-label={ariaLabelValue}>
      {children}
    </GatsbyLink>
  )
}

Link.propTypes = {
  href: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
  ariaLabel: PropTypes.string,
  icon: PropTypes.string,
}

export default Link
